export default {
  common: {
    loading: "Loading...",
  },
  header: {
    openMenu: "Open menu",
    home: "Home",
    language: "Language",
    searchPlaceholder: "Search a page...",
    searchLabel: "Search a page",
    noResult: "No results found",
    notifications: "Notifications",
    notificationsUnread: "Notifications, {count} unread",
    markAllRead: "Mark all as read",
    noNotifications: "No notifications",
    onlineAccount: "Account online",
    myAccount: "My account",
    myProfile: "My profile",
    profile: "Profile",
    settings: "Settings",
    logout: "Log out",
    roleAdmin: "Admin",
    roleClient: "Client",
    roleDriver: "Driver",
    roleZoneManager: "Zone manager",
    justNow: "Just now",
    minutesAgo: "{n} min ago",
    hoursAgo: "{n} h ago",
  },
  theme: {
    enableLight: "Switch to light mode",
    enableDark: "Switch to dark mode",
    light: "Light mode",
    dark: "Dark mode",
  },
  sidebar: {
    mainNav: "Main navigation",
    mainMenu: "Main menu",
    closeMenu: "Close menu",
    loadingMenu: "Loading menu",
  },
  menu: {
    dashboard: "Dashboard",
    parcels: "Parcels",
    distributionNotes: "Distribution notes",
    exchanges: "Exchange",
    returns: "Returns",
    refunds: "Refunds",
    driverInvoices: "Driver invoices",
    myProfile: "My profile",
    apiDocs: "API documentation",
    deliveryNotes: "Delivery notes",
    parcelReception: "Parcel reception",
    sentNotes: "Dispatch notes",
    zoneInvoices: "Zone invoices",
    zoneReturns: "Zone returns",
    claims: "Claims",
    users: "Users",
    usersList: "User list",
    newDrivers: "New drivers",
  },
};
